export default "__VITE_ASSET__a38080b7__"